import React, {Component} from 'react';
import {Icon} from 'antd'

class Loading extends Component {
    render() {
        return (
            <div className="data-load"><p><Icon type="loading" style={{fontSize: 28}} /></p><span>正在加载...</span></div>
        );
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.jsx